import Cookies from 'js-cookie'
import config from '../../../config'

const ADMIN_COUPON_API_URL = `${config.apiAdminGateway}/api/v1/admin/coupon`

export const getOrdersByStatus = async (status, isIssue = undefined, page = 1) => {
  try {
    const params = {
      status,
      page,
    }
    if (isIssue !== undefined) {
      params.isIssue = isIssue
    }
    const response = await fetch(`${ADMIN_COUPON_API_URL}/orders?` + new URLSearchParams(params), {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
        Authorization: `Bearer ${Cookies.get('accessToken')}`,
      },
    })

    if (response.status === 200) {
      const json = await response.json()
      if (json?.data?.length > 0) {
        return json.data
      }
      return []
    }
    return []
  } catch (error) {
    console.error('getOrdersByStatus error ---> ', error)
    return []
  }
}

export const getOrders = async (params) => {
  try {
    const response = await fetch(`${ADMIN_COUPON_API_URL}/orders?${params}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
        Authorization: `Bearer ${Cookies.get('accessToken')}`,
      },
    })
    if (response.status === 200) {
      const json = await response.json()
      if (json?.data?.length > 0) {
        return json.data
      }
      return []
    }
    return []
  } catch (error) {
    console.error('getOrdersByStatus error ---> ', error)
    return []
  }
}

export const getOtherOrders = async (userNo) => {
  try {
    const response = await fetch(`${ADMIN_COUPON_API_URL}/orders?userNo=${userNo}`, {
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
        Authorization: `Bearer ${Cookies.get('accessToken')}`,
      },
    })
    if (response?.status === 200) {
      const json = await response.json()
      return json.data
    }
    return []
  } catch (error) {
    console.error(error)
    return []
  }
}

export const lockOrder = async (hashId) => {
  try {
    await fetch(`${ADMIN_COUPON_API_URL}/orders/lock`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
        Authorization: `Bearer ${Cookies.get('accessToken')}`,
      },
      body: JSON.stringify({ orderId: hashId }),
    })
  } catch (error) {
    console.error(error)
  }
}

export const approveOrder = async (hashId) => {
  try {
    const response = await fetch(`${ADMIN_COUPON_API_URL}/orders/approve`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
        Authorization: `Bearer ${Cookies.get('accessToken')}`,
      },
      body: JSON.stringify({ id: hashId }),
    })

    if (response?.status === 200) {
      return { success: true }
    }
    return { success: false }
  } catch (error) {
    console.error('approveOrder error ---> ', error)
    return { success: false }
  }
}

export const cancelOrder = async (hashId, cancelReason, isForce) => {
  try {
    const response = await fetch(`${ADMIN_COUPON_API_URL}/orders/cancel`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
        Authorization: `Bearer ${Cookies.get('accessToken')}`,
      },
      body: JSON.stringify({ orderId: hashId, cancelReason, isForce }),
    })
    if (response?.status === 200) {
      return { success: true }
    }
    return { success: false }
  } catch (error) {
    console.log('cancelOrder error ---> ', error)
    return { success: false }
  }
}

export const saveNoteInOrder = async (hashId, note) => {
  try {
    const response = await fetch(`${ADMIN_COUPON_API_URL}/orders/note`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
        Authorization: `Bearer ${Cookies.get('accessToken')}`,
      },
      body: JSON.stringify({ id: hashId, note: note }),
    })
    if (response?.status === 200) {
      return { success: true }
    }
    return { success: false }
  } catch (error) {
    console.error('saveNote error ---> ', error)
    return { success: false }
  }
}

export const moveOrderToIssue = async (body) => {
  try {
    const response = await fetch(`${ADMIN_COUPON_API_URL}/orders/setIssue`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
        Authorization: `Bearer ${Cookies.get('accessToken')}`,
      },
      body: JSON.stringify(body),
    })
    if (response?.status === 200) {
      return { success: true }
    } else {
      return { success: false }
    }
  } catch (error) {
    console.error('moveOrderToIssue error ---> ', error)
    return { success: false }
  }
}

export const getOrdersLocked = async () => {
  try {
    const response = await fetch(`${ADMIN_COUPON_API_URL}/orders?isLock=true`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
        Authorization: `Bearer ${Cookies.get('accessToken')}`,
      },
    })
    if (response?.status === 200) {
      const json = await response.json()
      return json.data
    } else {
      return []
    }
  } catch (error) {
    console.error('getOrdersLocked error ---> ', error)
    return []
  }
}
